import { EventBus, EnumEventBus } from "../EventBus";
import Angle from "../../../../../src/entities/Angle/Angle";
import { Coord } from "../../../../../src/types/Interface";

import { ANGLE_COLORS } from "../../types/Config";
import { drawAngle, drawGuideAngles } from "./helpers/drawHelpers";
import { generateAnglePoints } from "../../../../../src/utils/generateAnglePoints";
import calculateAngle from "../../../../../src/utils/calculateAngle";


export default class AngleManager {
  private EventBus = EventBus;
  private angles = ANGLE_COLORS.map((color, colorI) => new Angle(`a${colorI + 1}`, { color, textColor: color }, 44));
  private isSuppMode: boolean = false;
  private currAngles: number[] = [];
  constructor() {
    this.EventBus.on(EnumEventBus.supplementaryMode, (v: boolean) => this.isSuppMode = v);
  }

  private emitAngles = (degrees: number[]) => this.EventBus.emit(EnumEventBus.setCalcLines, degrees);
  getAngles = () => this.angles;
  drawGuideAngle = (pArr: Coord[], degrees: number[]) => drawGuideAngles(this.angles[0], this.angles[3], degrees, pArr, false);

  setAllVisible(v: boolean) {
    this.angles.forEach(angle => angle.setVisible(v));
  }

  draw(pointArr: Coord[], clockwise: boolean) {
    const points = generateAnglePoints(pointArr);
    const angle1 = calculateAngle(points[0].prev, points[0].curr, points[0].next)
    const angle2 = calculateAngle(points[1].prev, points[1].curr, points[1].next)


    const degrees = [angle1, angle2, 180 - angle1, 180 - angle2];

    points.forEach((p, pI) => drawAngle(this.angles[pI], p, degrees[pI], clockwise))

    this.isSuppMode && this.drawGuideAngle(pointArr, [degrees[0], degrees[3]]);
    this.emitAngles(Array(4).fill(null).map((_, i) => degrees[i]));
  }
}